import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../components/common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { update_gym_cities_metadata } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";

const GymMetadatForm = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const rowDataJSON = rowData?.meta_json ? JSON.parse(rowData.meta_json) : null;

  const forminitials = {
    metaTitle: rowDataJSON?.title || "",
    h1Tag: rowDataJSON?.h1 || "",
    canonicalUrl: rowDataJSON?.canonical_url || "",
    metaDescription: rowDataJSON?.description || "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function validateForm(formValues) {
    let errors = {};

    if (!formValues.metaTitle) {
      errors.metaTitle = "required";
    }

    if (!formValues.h1Tag) {
      errors.h1Tag = "required";
    }

    if (!formValues.canonicalUrl) {
      errors.canonicalUrl = "required";
    }

    if (!formValues.metaDescription) {
      errors.metaDescription = "required";
    }

    return errors;
  }

  const onSubmit = () => {
    const erros = validateForm(formValues);
    setFormErrors(erros);

    if (Object.keys(erros)?.length === 0) {
      const metaJSON = {
        title: formValues.metaTitle || "",
        h1: formValues.h1Tag || "",
        description: formValues.metaDescription || "",
        canonical_url: formValues.canonicalUrl || "",
      };

      const userData = {
        city_id: rowData?.city_id || "",
        meta_json: JSON.stringify(metaJSON),
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm To Submit The Form!`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = update_gym_cities_metadata;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        setFormValues(forminitials);
        callFunction();
        closeModal();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  return (
    <div className="createNewCTOModalContainer midWidthModal">
      <CommonHeadingNBtns
        title={`Manage Meta Details`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer mb30">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="metaTitle" className="formInputLabel">
              Meta Title <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Meta Title"
              className={`formInput ${
                formErrors?.metaTitle ? "formError" : ""
              }`}
              name="metaTitle"
              value={formValues.metaTitle}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="h1Tag" className="formInputLabel">
              H1 Tag <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter H1 Tag"
              className={`formInput ${formErrors?.h1Tag ? "formError" : ""}`}
              name="h1Tag"
              value={formValues.h1Tag}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="canonicalUrl" className="formInputLabel">
              Canonical URL <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Canonical Url"
              className={`formInput ${
                formErrors?.canonicalUrl ? "formError" : ""
              }`}
              name="canonicalUrl"
              value={formValues.canonicalUrl}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="metaDescription" className="formInputLabel">
              Meta Description <span className="required">*</span>
            </label>

            <textarea
              name="metaDescription"
              className={`formInput ${
                formErrors.metaDescription ? "formError" : ""
              }`}
              placeholder="Enter Description"
              value={formValues.metaDescription}
              onChange={onChangeInput}
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GymMetadatForm;
